export class UserDto {
  private id: number | null;
  private email: string | null;
  private fullName: string | null;
  private mobile: string | null;
  private password: string | null;
  private status: number | null;
  private userName: string | null;
  private userType: number | null;
  private userValidity: Date | null;
  private version: number | null;
  private roleId: number | null;
  private roleName: string | null;

  constructor(data?: any) {
    this.id = data?.id ?? null;
    this.email = data?.email ?? null;
    this.fullName = data?.fullName ?? null;
    this.mobile = data?.mobile ?? null;
    this.password = data?.password ?? null;
    this.status = data?.status ?? null;
    this.userName = data?.userName ?? null;
    this.userType = data?.userType ?? null;
    this.userValidity = data?.userValidity ? new Date(data.userValidity) : null;
    this.version = data?.version ?? null;
    this.roleId = data?.roleId ?? null;
    this.roleName = data?.roleName ?? null;
  }

  // Getters
  getId(): number | null {
    return this.id;
  }
  getEmail(): string | null {
    return this.email;
  }
  getFullName(): string | null {
    return this.fullName;
  }
  getMobile(): string | null {
    return this.mobile;
  }
  getPassword(): string | null {
    return this.password;
  }
  getStatus(): number | null {
    return this.status;
  }
  getUserName(): string | null {
    return this.userName;
  }
  getUserType(): number | null {
    return this.userType;
  }
  getUserValidity(): Date | null {
    return this.userValidity;
  }
  getVersion(): number | null {
    return this.version;
  }
  getRoleId(): number | null {
    return this.roleId;
  }
  getRoleName(): string | null {
    return this.roleName;
  }

  // Setters
  setId(id: number | null): void {
    this.id = id;
  }
  setEmail(email: string | null): void {
    this.email = email;
  }
  setFullName(fullName: string | null): void {
    this.fullName = fullName;
  }
  setMobile(mobile: string | null): void {
    this.mobile = mobile;
  }
  setPassword(password: string | null): void {
    this.password = password;
  }
  setStatus(status: number | null): void {
    this.status = status;
  }
  setUserName(userName: string | null): void {
    this.userName = userName;
  }
  setUserType(userType: number | null): void {
    this.userType = userType;
  }
  setUserValidity(userValidity: Date | null): void {
    this.userValidity = userValidity;
  }
  setVersion(version: number | null): void {
    this.version = version;
  }
  setRoleId(roleId: number | null): void {
    this.roleId = roleId;
  }
  setRoleName(roleName: string | null): void {
    this.roleName = roleName;
  }
}
